import React from 'react';
import { SaveOutlined, SearchOutlined, SettingOutlined } from '@ant-design/icons';
import { Row, Col, Space, Button, Divider } from 'antd';
import design from '../../../assets/icons/design/01.svg';

export default function Header(props) {
    return (
        <Row wrap={true} className='mb-35'>
            <Col flex="auto">
                <div className='vertical-center'>
                    <Space wrap>
                        <img src={design} height={24} alt="img" className='align-middle' />
                        <span className='title-page'>Diseño y Visualización</span>
                    </Space>
                </div>
            </Col>
            <Col flex="none">
                <Space wrap>
                    <Button
                        type='primary'
                        shape='round'
                        icon={<SaveOutlined />}
                        onClick={props.onSave}
                    >
                        Guardar
                    </Button>
                </Space>
            </Col>
        </Row>
    )
}